export default "__VITE_ASSET__CLA5Da5y__"